import * as React from 'react';
import { FollowButton } from 'components/Common/FollowButton';
require('./style.css');

interface IProps {
	name: string;
	onClick?: any;
	onFollow?: any;
	onUnfollow?: any;
	isFollowing?: boolean;
}

interface IState {
	marqueeSize: number;
}
/**
 *
 * @param props
 */
class CardItemProfileName extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			marqueeSize: 0,
		};

		this.checkWidth = this.checkWidth.bind(this);
	}

	private holderRef = React.createRef<HTMLAnchorElement>();
	private textElementRef = React.createRef<HTMLSpanElement>();

	public componentDidMount(): void {
		this.checkWidth();
		// document.addEventListener('resize', this.checkWidth);
		if (typeof window !== 'undefined') {
			window.addEventListener('resize', this.checkWidth);
		}
	}

	public componentWillUnmount(): void {
		// document.removeEventListener('resize', this.checkWidth);
		if (typeof window !== 'undefined') {
			window.removeEventListener('resize', this.checkWidth);
		}
	}

	private checkWidth() {
		if (!this.holderRef.current || !this.textElementRef.current) {
			if (this.state.marqueeSize !== 0) {
				this.setState({ marqueeSize: 0 });
			}
			return;
		}
		const marqueeSize = this.textElementRef.current.offsetWidth;
		const sizeOver = Math.max(0, marqueeSize - this.holderRef.current.clientWidth);
		if (sizeOver > 0) {
			if (marqueeSize !== this.state.marqueeSize) {
				this.setState({ marqueeSize });
			}
		} else if (this.state.marqueeSize !== 0) {
			this.setState({ marqueeSize: 0 });
		}
	}

	public render() {
		const { name, onClick, onFollow, isFollowing, onUnfollow } = this.props;
		const { marqueeSize } = this.state;
		const onViewProfileClick = (e) => {
			if (onClick) {
				onClick(e);
			}
		};
		const buttonProps = {
			follow: onFollow,
			unfollow: onUnfollow,
			isFollowing,
		};

		const animationDuration = marqueeSize * 0.03 + 's';

		return (
			<div className="profileItemCardName">
				<a href="#" onClick={(e) => onViewProfileClick(e)} ref={this.holderRef}>
					<span
						className={'name' + (marqueeSize ? ' sizeOver' : '')}
						ref={this.textElementRef}
						style={marqueeSize ? { animationDuration } : undefined}
					>
						{name}
					</span>
					{marqueeSize ? (
						<span className="name sizeOver copy" style={{ animationDuration }}>
							{name}
						</span>
					) : null}
				</a>
				{onFollow ? <FollowButton {...buttonProps} /> : undefined}
			</div>
		);
	}
}

export { CardItemProfileName };
